const menu = {
    label: 'Regras de Acesso',
    icon: 'pi pi-fw pi-key',
    to: '/controleacesso/regras',
    rules: ['CTRLACS-RA-00'],
};

export default menu;
